import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/core/services/utils.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-note-legali-popup',
  templateUrl: './note-legali-popup.component.html',
  styleUrls: ['./note-legali-popup.component.scss']
})
export class NoteLegaliPopupComponent implements OnInit {

 supportEmail: string = environment.actiaSupportEmail;
 supportPhone: string = environment.actiaSupportPhone;
 actiaFooterText: string = `© ${new Date().getFullYear()} ${environment.actiaFooterText}`;
  isFleet: boolean = false;
  tenantColorClass: string;
  // Data Act: la sezione richiesta dati non va mostrata sui tenant ucontrol e cela
  showDataActSection: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<NoteLegaliPopupComponent>,
    private dialog: MatDialog,
    private router: Router,
    private translateService: TranslateService,
      private utilsService: UtilsService
  ) { }
  ngOnInit(): void {
    const tenant = this.utilsService.getStylesheetString();
    this.tenantColorClass = tenant + '-theme';
    this.showDataActSection = tenant !== 'ucontrol' && tenant !== 'cela';


    switch (location.host) {
      case 'argofleet.argotractors.com':
      case '178.255.75.102':
      case 'test.argofleet.argotractors.com':
        this.supportEmail = environment.mailArgoTractors;
        this.supportPhone = '';
        break;
      case 'landinifleet.argotractors.com':
      case 'test.landinifleet.argotractors.com':
        this.supportEmail = environment.mailArgoTractors;
        this.supportPhone = '';
        break;
      case 'mccormickfleet.argotractors.com':
      case 'test.mccormickfleet.argotractors.com':
        this.supportEmail = environment.mailArgoTractors;
        this.supportPhone = '';
        break;
      case 'www.u-control.cloud':
        this.supportEmail = environment.mailUcontrol;
        this.supportPhone = '';
        break;
      case 'test.ucontrol.actiafleet4agri.com':
        this.supportEmail = environment.mailUcontrol;
        this.supportPhone = '';
        break;
      case 'www.essential-connect.it':
      case 'essential-connect.it':
      case 'test.cela.actiafleet4agri.com':
        this.supportEmail = environment.mailCela;
        this.supportPhone = '';
        break;

      default:
        this.supportEmail = environment.actiaSupportEmail;
        this.supportPhone = environment.actiaSupportPhone;
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  openUserDataRequest(): void {
    this.dialogRef.close();
    this.router.navigate(['app/privacy/requireData']);
  }
}
